import './init';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import React from 'react';
import 'whatwg-fetch';
import { createRoot } from 'react-dom/client';

import App from './app';

import './index.css';
import './fontawesome.css';
// favicon related imports
import './favicon.ico';

LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-063642}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Tassat_Group_LLC}_is_granted_a_{Multiple_Applications}_Developer_License_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{24_September_2025}____[v3]_[01]_MTc1ODY2ODQwMDAwMA==99c518002bb6b169f838210945d092e7');
ModuleRegistry.registerModules([ ClientSideRowModelModule, SetFilterModule ]);

const root = createRoot(document.getElementById('root'));

root.render(<App isAdmin={false} />);